import React from 'react'
import { useAppSelector } from '../../hooks/useStore'
import PassportHandoffScreen from '../PassportHandoffScreen'
import PassPortUpsellTS from './PassPortUpsellTS'

function PassPortUpsellScreen() {
  const stationId = useAppSelector((state) => state.station.station_id)

  if (!stationId) {
    return <PassPortUpsellTS />
  }

  return <PassportHandoffScreen />
}

export default PassPortUpsellScreen
